import { Fancybox } from "@fancyapps/ui";

export class Gallery {
    private _galleryElement: HTMLElement;

    constructor(galleryElement: HTMLElement) {
        this._galleryElement = galleryElement;
    }

    public init() {
        if (this._galleryElement) {
            console.log(this._galleryElement)
            Fancybox.bind(this._galleryElement, "[data-fancybox]");
        }
    }
}